//
//
//
//
//
//
//
//
//
//
//
//
//


export default {
    data () {
        return {
            tags: [
                '在售', '即将预售', '最新取证', '热门楼盘'
            ]
        }
    },
    methods: {
        onSelect (e) {
            const { tag } = e.currentTarget.dataset
            this.$emit('change', this.status === tag ? '' : tag)
        }
    },
    props: {
        status: {
            type: String
        }
    }
}
